import { useState, useEffect } from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';
import { Accordion } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from '../../../../../Sidebar/Sidebar';
import AppLink from '../../../../../../routing/helpers/AppLink';
import FilterSidebarBlock from './FilterSidebarBlock';
import ReportSidebarBlock from './ReportSidebarBlock';
import Translator from '../../../../../components/helpers/Translator';
import _ from 'lodash';

export default function GlobalEvaluationSidebar() {
  const { moduleBridgeHex } = useParams();
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.permissions
  );
  const auth = useSelector((state) => state.auth);
  const global = useSelector((state) => state.global);
  const [manualLang, setManualLang] = useState('en');

  useEffect(() => {
    if (['es', 'en', 'fr'].includes(global?.urlData?.lang)) {
      setManualLang(global?.urlData?.lang);
    }
  }, [global]);

  if (!permissions) return <Sidebar toggleable={false} />;

  return (
    <>
      <Sidebar>
        <img
          src={auth.user?.client?.logoUrl}
          className="img-fluid"
          alt={auth.user?.client?.name}
          title={auth.user?.client?.name}
        />
        <Accordion>
          <ul>
            {permissions.ggcl?.filters && <FilterSidebarBlock />}
            {_.find(permissions.ggcl.reports, (r) => r !== false) && (
              <ReportSidebarBlock />
            )}
            {permissions.ggcl?.yearCalendar && (
              <li>
                <span className="sidebar-element">
                  <AppRemixIcon icon="calendar" className="sidebar-icon" />{' '}
                  <AppLink
                    path="user_module_globalLegalCompliance_calendar"
                    params={{
                      moduleBridgeHex,
                    }}
                    className="sb-title"
                    style={{ padding: '0', color: '#212529' }}
                  >
                    <Translator file="user" name="user.calendar" />
                  </AppLink>
                </span>
              </li>
            )}
            <li>
              <span className="sidebar-element">
                <AppRemixIcon icon="question" className="sidebar-icon" />{' '}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`https://worldlex-files.s3.eu-central-1.amazonaws.com/GUIA_gestor_global_${manualLang}_v1.pdf`}
                  className="sb-title"
                  style={{ padding: '0', color: '#212529' }}
                >
                  <Translator
                    file="module-globallegalCompliance"
                    name="manual"
                  />
                </a>
              </span>
            </li>
          </ul>
        </Accordion>
      </Sidebar>
    </>
  );
}
